import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const PitchCorr = () => {
	const {fps} = useVideoConfig();
	// Keep the cursor and the captured video on their original 60 fps clock.
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<>
			<Video
				src="https://remotion.media/studio-close-ups/pitch-correction-2026-09-23-13-36.mp4"
				durationInFrames={(1052 / 60) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[5, 220, 225, 251, 253, 553, 560, 579, 582, 831, 858, 859],
					[
						'auto',
						'default',
						'ew-resize',
						'default',
						'ew-resize',
						'col-resize',
						'auto',
						'default',
						'ew-resize',
						'auto',
						'col-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 241, 553, 604, 813, 925, 933],
						[
							4.321282880855254, 3.8891545927697284, 4.321282880855254,
							3.8891545927697284, 4.321282880855254, 3.8891545927697284,
							4.321282880855254,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							5, 6, 7, 8, 9, 10, 11, 12, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
							37, 38, 39, 40, 41, 168, 169, 170, 171, 172, 173, 174, 175, 176,
							177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189,
							190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202,
							203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215,
							216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228,
							229, 230, 231, 232, 233, 234, 235, 246, 247, 248, 249, 250, 251,
							252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264,
							265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277,
							278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290,
							291, 292, 293, 294, 296, 297, 298, 299, 300, 301, 302, 303, 304,
							305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317,
							318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330,
							331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343,
							344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356,
							357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369,
							370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382,
							383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395,
							396, 397, 398, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420,
							421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433,
							434, 435, 436, 437, 438, 448, 449, 450, 451, 452, 453, 454, 455,
							456, 457, 458, 459, 460, 466, 467, 468, 469, 471, 472, 473, 484,
							485, 486, 487, 488, 489, 490, 491, 492, 496, 497, 498, 519, 520,
							521, 522, 546, 547, 548, 550, 551, 552, 553, 558, 559, 560, 561,
							562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574,
							575, 576, 577, 578, 579, 580, 581, 582, 583, 585, 586, 587, 588,
							589, 590, 591, 592, 593, 594, 595, 596, 613, 614, 615, 616, 617,
							618, 619, 620, 621, 622, 623, 624, 625, 626, 627, 628, 629, 630,
							631, 632, 633, 634, 635, 636, 637, 638, 639, 640, 641, 642, 643,
							644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 654, 655, 656,
							657, 658, 659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669,
							670, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682,
							683, 684, 685, 686, 687, 688, 689, 690, 691, 692, 693, 694, 695,
							696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708,
							709, 710, 711, 712, 713, 714, 715, 716, 717, 718, 719, 720, 721,
							722, 723, 724, 725, 726, 727, 728, 729, 730, 731, 732, 733, 734,
							735, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752,
							753, 754, 755, 772, 773, 774, 775, 776, 777, 778, 779, 780, 830,
							831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843,
							844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856,
							857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869,
							870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 880, 881, 882,
							883, 884, 885, 886, 887, 888, 889, 890, 891, 892, 893, 897, 898,
							899, 900, 901, 902, 903, 904, 905, 906, 907, 908, 909,
						],
						[
							'2978.2923055282035px 1510.7103671402447px',
							'3019.428892952595px 1462.0621747081163px',
							'3090.3080602053733px 1379.0800393866928px',
							'3142.3660149106763px 1318.8859192572795px',
							'3184.279082852722px 1274.4746096497397px',
							'3230.8679139119427px 1236.106344070896px',
							'3231.9144746096495px 1235.2454634969756px',
							'3234.176396117597px 1233.422422281615px',
							'3234.176396117597px 1233.422422281615px',
							'3232.859755239837px 1233.287382191588px',
							'3226.394710929807px 1232.6290617527077px',
							'3224.7911098607397px 1230.8566605711069px',
							'3219.912786608524px 1219.6989731326487px',
							'3222.073428048952px 1202.869601913068px',
							'3222.073428048952px 1202.869601913068px',
							'3295.822197214798px 1083.8824025882684px',
							'3334.7306231537486px 1051.1351807567871px',
							'3368.220565480377px 1031.908847939232px',
							'3372.288648192432px 1029.5456463637643px',
							'3372.035448023632px 1029.4950063300041px',
							'3367.3428048952032px 1028.9379659586439px',
							'3357.130398086932px 1028.0264453509635px',
							'3353.9063159375437px 1027.4356449570967px',
							'3353.9063159375437px 1027.4356449570967px',
							'3352.336474890983px 1027.4356449570967px',
							'3232.3027148684764px 1025.2074834716557px',
							'3232.3027148684764px 1025.2074834716557px',
							'2933.4083556055703px 1038.8127725418483px',
							'2933.4083556055703px 1038.8127725418483px',
							'2801.6429877619917px 1075.4086369390911px',
							'2801.6429877619917px 1075.4086369390911px',
							'2633.4505556337035px 1144.8023632015754px',
							'2633.4505556337035px 1144.8023632015754px',
							'2574.4042762695176px 1172.2323814882543px',
							'2417.487691658461px 1212.1029680686454px',
							'2398.9365592910394px 1213.6052890701926px',
							'2398.9365592910394px 1213.6052890701926px',
							'2397.332958221972px 1213.4871289914192px',
							'2387.4075116050076px 1212.4743283162188px',
							'2374.2242228161485px 1210.161766774511px',
							'2348.600365733577px 1204.7939231959488px',
							'2313.439302292868px 1195.1891967927977px',
							'2248.164298776199px 1177.46518497679px',
							'2174.1454494302993px 1160.6189337459557px',
							'2078.7058658039105px 1142.3378815585877px',
							'1979.333239555493px 1125.1877901251933px',
							'1750.3390068926713px 1098.1628921085946px',
							'1541.1956674637781px 1067.9307919538612px',
							'1451.596567731045px 1055.8953439302293px',
							'1383.6376424250948px 1046.1893374595581px',
							'1303.862709241806px 1036.3314108876073px',
							'1246.7238711492473px 1029.7650865100577px',
							'1191.5431143620763px 1026.4566043044028px',
							'1140.1266000844px 1021.8314812209875px',
							'1117.49050499367px 1020.3122802081867px',
							'1111.7681811787875px 1020.3122802081867px',
							'1100.644253762836px 1020.3122802081867px',
							'1083.5785623857082px 1020.3122802081867px',
							'1051.472780981854px 1019.5189196792797px',
							'1015.7209171472781px 1017.6958784639189px',
							'986.9742579828386px 1016.463637642425px',
							'970.448726965818px 1016.3285975523983px',
							'953.8725559150372px 1015.568997045998px',
							'930.1223800815867px 1014.5899563933042px',
							'914.5927697285131px 1014.083556055704px',
							'900.3122802081867px 1014.083556055704px',
							'891.9397946265298px 1014.083556055704px',
							'880.7483471655647px 1014.4549163032775px',
							'872.3758615839076px 1015.4001969334646px',
							'859.6820931213954px 1015.6365170910113px',
							'847.1064847376565px 1015.6365170910113px',
							'828.9773526515684px 1015.6365170910113px',
							'818.4273456182303px 1016.1429174286116px',
							'804.6026164017443px 1016.1429174286116px',
							'792.0270080180053px 1016.1429174286116px',
							'778.438598959066px 1016.1429174286116px',
							'765.1709101139401px 1016.311717541145px',
							'762.9427486284991px 1016.463637642425px',
							'761.0521873681249px 1016.1429174286116px',
							'758.233225488817px 1016.0247573498382px',
							'756.5958643972428px 1016.0247573498382px',
							'753.5237023491349px 1016.0247573498382px',
							'751.8019412012941px 1016.0247573498382px',
							'747.4131382754255px 1016.0247573498382px',
							'740.8468138978759px 1016.2273174848783px',
							'733.2845688563792px 1016.5142776761851px',
							'726.7013644675762px 1016.5142776761851px',
							'723.6292024194682px 1016.5142776761851px',
							'721.3672809115205px 1016.5142776761851px',
							'719.7974398649599px 1016.8181178787452px',
							'719.3416795611197px 1016.8181178787452px',
							'719.3416795611197px 1016.8181178787452px',
							'721.7386411590941px 1017.155718103812px',
							'721.7386411590941px 1017.155718103812px',
							'746.0796173864115px 1018.7255591503728px',
							'746.0796173864115px 1018.7255591503728px',
							'764.1412294274862px 1020.3798002532001px',
							'764.1412294274862px 1020.3798002532001px',
							'809.6328597552398px 1024.734843156562px',
							'809.6328597552398px 1024.734843156562px',
							'814.4267829511886px 1024.8698832465889px',
							'818.7649458432971px 1025.1062034041356px',
							'818.7649458432971px 1025.1062034041356px',
							'828.7410324940216px 1025.1062034041356px',
							'836.3876775917851px 1025.1062034041356px',
							'842.8527219018146px 1025.1062034041356px',
							'849.3684062456041px 1025.1062034041356px',
							'857.0994513996342px 1025.1062034041356px',
							'862.2647348431565px 1025.1062034041356px',
							'870.6372204248136px 1025.1062034041356px',
							'879.2460261640174px 1025.1062034041356px',
							'886.8420312280208px 1025.376283584189px',
							'894.7587565058376px 1025.6126037417357px',
							'901.4094809396539px 1025.6126037417357px',
							'906.1696441130961px 1025.6126037417357px',
							'912.6684484456323px 1025.6126037417357px',
							'916.5339710226473px 1026.0514840343226px',
							'920.4501336334224px 1026.4228442818962px',
							'923.1846954564636px 1026.4228442818962px',
							'926.8476578984386px 1026.4228442818962px',
							'926.8476578984386px 1026.4228442818962px',
							'931.7935011956674px 1026.6929244619496px',
							'934.1229427486285px 1026.6929244619496px',
							'936.6043044028695px 1026.6929244619496px',
							'942.3772682515121px 1026.6929244619496px',
							'942.3772682515121px 1026.6929244619496px',
							'944.4535096356731px 1026.6929244619496px',
							'947.2555915037276px 1026.6929244619496px',
							'955.644957096638px 1027.064284709523px',
							'955.644957096638px 1027.064284709523px',
							'959.8818399212265px 1027.3006048670698px',
							'964.4732029821353px 1027.3006048670698px',
							'972.2717681811787px 1027.3006048670698px',
							'972.2717681811787px 1027.3006048670698px',
							'976.5592910395274px 1027.3006048670698px',
							'982.1128147418765px 1027.70572513715px',
							'982.1128147418765px 1027.70572513715px',
							'984.6110564073709px 1027.70572513715px',
							'987.7507385004923px 1027.70572513715px',
							'992.3252215501476px 1027.70572513715px',
							'992.3252215501476px 1027.70572513715px',
							'995.9375439583625px 1027.70572513715px',
							'997.8281052187367px 1027.70572513715px',
							'999.6005064003375px 1027.70572513715px',
							'1000.9846673231115px 1027.70572513715px',
							'1003.0102686735124px 1027.70572513715px',
							'1003.0102686735124px 1027.70572513715px',
							'1005.4578703052468px 1027.70572513715px',
							'1006.3018708679139px 1027.70572513715px',
							'1007.9392319594879px 1027.70572513715px',
							'1010.6906737937825px 1027.70572513715px',
							'1012.75003516669px 1027.70572513715px',
							'1013.6109157406105px 1027.70572513715px',
							'1013.6109157406105px 1027.70572513715px',
							'1015.619637079758px 1027.70572513715px',
							'1018.050358700239px 1027.70572513715px',
							'1023.3000422000281px 1027.2330848220565px',
							'1023.3000422000281px 1027.2330848220565px',
							'1025.0049233366155px 1027.2330848220565px',
							'1028.195245463497px 1027.2330848220565px',
							'1031.0310873540582px 1027.2330848220565px',
							'1033.6643691095794px 1027.2330848220565px',
							'1036.719651146434px 1027.3343648895766px',
							'1038.508932339288px 1027.55380503587px',
							'1039.538613025742px 1027.55380503587px',
							'1041.1084540723027px 1027.55380503587px',
							'1043.1340554227036px 1027.55380503587px',
							'1045.0077366718244px 1027.55380503587px',
							'1047.5059783373188px 1027.55380503587px',
							'1049.8185398790265px 1027.55380503587px',
							'1052.080461386974px 1027.55380503587px',
							'1054.2411028274018px 1027.55380503587px',
							'1056.7393444928962px 1027.55380503587px',
							'1056.7393444928962px 1027.55380503587px',
							'1060.2335068223379px 1027.55380503587px',
							'1062.6135884090588px 1027.9082852721901px',
							'1066.7154311436207px 1028.0095653397102px',
							'1068.656632437755px 1028.4146856097905px',
							'1068.656632437755px 1028.4146856097905px',
							'1071.1717541145026px 1028.4146856097905px',
							'1073.3830355886903px 1028.5497256998171px',
							'1074.2945561963706px 1028.7691658461106px',
							'1075.2398368265578px 1028.7691658461106px',
							'1075.9656773104514px 1028.7691658461106px',
							'1077.3160782107188px 1028.7691658461106px',
							'1079.3754395836263px 1028.7691658461106px',
							'1080.7427204951468px 1028.7691658461106px',
							'1081.9243212828808px 1028.7691658461106px',
							'1082.6670417780279px 1028.7691658461106px',
							'1083.8317625545083px 1028.7691658461106px',
							'1085.9586439724292px 1028.7691658461106px',
							'1088.1361654241102px 1028.7691658461106px',
							'1089.0476860317906px 1028.7691658461106px',
							'1092.4912083274721px 1028.7691658461106px',
							'1092.4912083274721px 1028.7691658461106px',
							'1093.0820087213392px 1029.0223660149106px',
							'1094.719369812913px 1029.0223660149106px',
							'1096.643691095794px 1029.0223660149106px',
							'1097.7915318610212px 1029.0223660149106px',
							'1098.7030524687016px 1029.0223660149106px',
							'1099.6483330988888px 1029.0223660149106px',
							'1100.8130538753692px 1029.0223660149106px',
							'1101.6739344492896px 1029.0223660149106px',
							'1103.7501758334506px 1029.0223660149106px',
							'1104.374736249824px 1029.0223660149106px',
							'1104.712336474891px 1029.0223660149106px',
							'1105.6744971163314px 1029.0223660149106px',
							'1106.2146574764383px 1029.0223660149106px',
							'1107.5819383879589px 1029.0223660149106px',
							'1108.7128991419327px 1029.0223660149106px',
							'1109.1348994232662px 1029.0223660149106px',
							'1110.0970600647067px 1029.0223660149106px',
							'1111.008580672387px 1029.0223660149106px',
							'1113.2029821353215px 1029.0223660149106px',
							'1114.4352229568153px 1029.3768462512307px',
							'1114.4352229568153px 1029.3768462512307px',
							'1116.9841046560698px 1029.3768462512307px',
							'1117.8281052187367px 1029.3768462512307px',
							'1119.1616261077506px 1029.3768462512307px',
							'1119.1616261077506px 1029.3768462512307px',
							'1120.1575467716978px 1029.3768462512307px',
							'1121.0859473906316px 1029.3768462512307px',
							'1121.1534674356449px 1029.3768462512307px',
							'1121.609227739485px 1029.3768462512307px',
							'1122.4532283021522px 1029.3768462512307px',
							'1122.4532283021522px 1029.3768462512307px',
							'1123.7529891686595px 1029.3768462512307px',
							'1124.1074694049796px 1029.3768462512307px',
							'1124.276269517513px 1029.3768462512307px',
							'1125.12027008018px 1029.3768462512307px',
							'1126.1499507666338px 1029.3768462512307px',
							'1127.0614713743141px 1028.9210859473906px',
							'1127.2640315093543px 1028.9210859473906px',
							'1127.7197918131944px 1028.9210859473906px',
							'1128.192432128288px 1028.9210859473906px',
							'1128.9520326346883px 1028.9210859473906px',
							'1129.9985933323956px 1028.9210859473906px',
							'1130.4881136587423px 1028.9210859473906px',
							'1130.5387536925025px 1028.9210859473906px',
							'1130.9269939513292px 1028.9210859473906px',
							'1132.0241946827964px 1028.9210859473906px',
							'1132.2773948515965px 1028.9210859473906px',
							'1132.6318750879166px 1028.9210859473906px',
							'1132.6318750879166px 1028.9210859473906px',
							'1134.1679561119706px 1028.397805598537px',
							'1136.8518779012518px 1027.80700520467px',
							'1136.8518779012518px 1027.80700520467px',
							'1139.77211984808px 1027.2668448445631px',
							'1140.1097200731467px 1027.2668448445631px',
							'1140.1097200731467px 1027.2668448445631px',
							'1141.5445210296807px 1027.2668448445631px',
							'1142.5910817273877px 1027.2668448445631px',
							'1143.0637220424812px 1027.2668448445631px',
							'1143.4688423125615px 1027.2668448445631px',
							'1143.9246026164017px 1027.2668448445631px',
							'1143.9583626389083px 1027.2668448445631px',
							'1144.5154030102685px 1027.2668448445631px',
							'1145.629483752989px 1027.2668448445631px',
							'1146.3215642143762px 1027.2668448445631px',
							'1146.659164439443px 1027.2668448445631px',
							'1147.5200450133632px 1027.2668448445631px',
							'1149.0054860036573px 1027.2668448445631px',
							'1149.9676466450976px 1027.2668448445631px',
							'1149.9676466450976px 1027.2668448445631px',
							'1150.2546068364045px 1027.2668448445631px',
							'1150.7103671402447px 1027.2668448445631px',
							'1151.3518075678717px 1027.2668448445631px',
							'1152.1789281192853px 1027.2668448445631px',
							'1152.516528344352px 1027.2668448445631px',
							'1152.516528344352px 1027.2668448445631px',
							'1153.1242087494725px 1027.2668448445631px',
							'1153.1242087494725px 1027.2668448445631px',
							'1154.390209593473px 1027.2668448445631px',
							'1154.390209593473px 1027.2668448445631px',
							'1154.6602897735265px 1027.2668448445631px',
							'1155.1160500773667px 1027.2668448445631px',
							'1155.4030102686734px 1027.2668448445631px',
							'1155.6393304262203px 1027.013644675763px',
							'1156.078210718807px 1026.7773245182163px',
							'1156.1963707975806px 1026.7773245182163px',
							'1156.1963707975806px 1026.7773245182163px',
							'1156.618371078914px 1026.7773245182163px',
							'1157.0403713602475px 1026.7773245182163px',
							'1157.4454916303278px 1026.7773245182163px',
							'1157.4454916303278px 1026.7773245182163px',
							'1157.5636517091011px 1026.7773245182163px',
							'1158.7114924743282px 1026.7773245182163px',
							'1158.897172598115px 1026.7773245182163px',
							'1158.897172598115px 1026.7773245182163px',
							'1159.3191728794486px 1026.7773245182163px',
							'1159.5217330144885px 1026.7773245182163px',
							'1159.5217330144885px 1026.7773245182163px',
							'1159.589253059502px 1026.7773245182163px',
							'1160.1631734421155px 1026.7773245182163px',
							'1160.635813757209px 1026.7773245182163px',
							'1161.1084540723027px 1026.7773245182163px',
							'1161.3954142636094px 1026.7773245182163px',
							'1161.3954142636094px 1026.7773245182163px',
							'1161.7161344774229px 1026.7773245182163px',
							'1161.8005345336896px 1026.7773245182163px',
							'1161.8005345336896px 1026.7773245182163px',
							'1162.0874947249965px 1026.7773245182163px',
							'1162.4250949500633px 1026.7773245182163px',
							'1162.4250949500633px 1026.7773245182163px',
							'1164.3156562104375px 1026.7773245182163px',
							'1164.940216626811px 1026.7773245182163px',
							'1165.142776761851px 1026.7773245182163px',
							'1165.142776761851px 1026.7773245182163px',
							'1165.142776761851px 1026.7435644957095px',
							'1165.142776761851px 1026.119004079336px',
							'1165.142776761851px 1026.119004079336px',
							'1165.142776761851px 1026.3890842593894px',
							'1165.142776761851px 1026.7435644957095px',
							'1164.7038964692642px 1026.7435644957095px',
							'1164.7038964692642px 1026.7435644957095px',
							'1164.7038964692642px 1026.1021240680827px',
							'1164.2818961879307px 1026.1021240680827px',
							'1162.7458151638766px 1026.3215642143762px',
							'1160.5007736671823px 1027.1486847657898px',
							'1155.0316500211px 1029.3262062174708px',
							'1145.325643550429px 1032.8878885919257px',
							'1126.3356308904206px 1037.6649317766212px',
							'1105.1849767899844px 1043.1171754114503px',
							'1057.2963848642564px 1055.9291039527359px',
							'1025.578843719229px 1066.0739907159937px',
							'999.4654663103108px 1076.8603179068787px',
							'973.3183288788858px 1089.5709663806442px',
							'954.7671965114642px 1097.8590519060344px',
							'937.2963848642565px 1104.6110564073708px',
							'919.7242931495288px 1109.7088198058798px',
							'902.7598818399211px 1113.236742157828px',
							'892.6318750879167px 1114.030102686735px',
							'873.084822056548px 1114.030102686735px',
							'850.6681671121114px 1114.030102686735px',
							'810.7975805317203px 1114.030102686735px',
							'787.3174848783232px 1115.0935433956956px',
							'771.3489942326628px 1116.4777043184695px',
							'761.9130679420452px 1117.2373048248699px',
							'757.2710648473766px 1117.7605851737235px',
							'756.7309044872696px 1117.8112252074834px',
							'756.7309044872696px 1117.8112252074834px',
							'756.7309044872696px 1117.94626529751px',
							'756.3764242509494px 1118.6045857363904px',
							'754.7897031931354px 1119.5329863553243px',
							'753.7937825291883px 1120.1237867491911px',
							'752.5109016739344px 1120.9171472780981px',
							'751.548741032494px 1121.4741876494584px',
							'750.5865803910535px 1122.3519482346321px',
							'749.1180194120129px 1122.9089886059924px',
							'745.0499366999578px 1124.124349416233px',
							'742.63609509073px 1125.2553101702067px',
							'741.741454494303px 1125.4747503165001px',
							'741.741454494303px 1125.4747503165001px',
							'741.2856941904628px 1125.4747503165001px',
							'738.5848923899282px 1125.9980306653538px',
							'734.7193698129132px 1127.095231396821px',
							'730.0436066957377px 1128.5806723871149px',
							'726.6338444225629px 1129.627233084822px',
							'720.2363201575467px 1132.1254747503165px',
							'717.029118019412px 1133.6784357856238px',
							'713.2479954986636px 1135.0625967083977px',
							'710.0407933605288px 1136.1597974398649px',
							'706.3103108735405px 1137.898438598959px',
							'704.1834294556196px 1138.6580391053594px',
							'700.1828667885778px 1140.17724011816px',
							'696.3679842453228px 1141.8990012660008px',
							'692.8738219158812px 1143.789562526375px',
							'690.2405401603601px 1145.1399634266422px',
							'686.8138978759318px 1146.6085244056828px',
							'683.5391756927837px 1147.6382050921366px',
							'680.6189337459558px 1148.887325924884px',
							'677.6142917428612px 1149.9170066113377px',
							'674.8628499085665px 1151.081727387818px',
							'672.4321282880854px 1151.9594879729918px',
							'668.7185258123505px 1152.9891686594458px',
							'665.3087635391756px 1153.6137290758193px',
							'660.1941201294134px 1154.6940497960331px',
							'655.3664369109579px 1155.2679701786467px',
							'652.7669151779435px 1155.6393304262203px',
							'650.2855535237023px 1155.9600506400336px',
							'647.3315515543677px 1156.1457307638204px',
							'643.3478688985792px 1156.4833309888872px',
							'640.2081868054578px 1156.719651146434px',
							'637.7605851737234px 1157.1247714165142px',
							'635.9881839921227px 1157.2260514840343px',
							'633.6249824166549px 1157.2260514840343px',
							'631.8188212125474px 1157.614291742861px',
							'629.269939513293px 1158.053172035448px',
							'626.8729779153185px 1158.053172035448px',
							'624.4084962723308px 1158.2726121817414px',
							'623.0243353495568px 1158.407652271768px',
							'621.5220143480095px 1158.407652271768px',
							'619.7664931776621px 1158.7283724855815px',
							'617.8252918835279px 1158.8634125756084px',
							'616.9981713321142px 1159.0828527219016px',
							'616.1372907581938px 1159.0997327331552px',
							'614.4830496553664px 1159.589253059502px',
							'613.2508088338725px 1159.589253059502px',
							'612.2211281474188px 1159.7580531720355px',
							'610.9720073146715px 1160.0787733858488px',
							'609.7735265156844px 1160.3657335771557px',
							'608.6425657617104px 1160.5682937121958px',
							'607.8154452102967px 1160.922773948516px',
							'606.3131242087494px 1161.0071740047827px',
							'605.5197636798424px 1161.024054016036px',
							'604.557603038402px 1161.4460542973695px',
							'603.4941623294416px 1161.4460542973695px',
							'602.5826417217611px 1161.6486144324097px',
							'601.7217611478408px 1161.868054578703px',
							'601.7217611478408px 1161.868054578703px',
							'599.8143198762132px 1161.868054578703px',
							'599.409199606133px 1162.2562948375298px',
							'598.4132789421859px 1162.3406948937966px',
							'597.4511183007455px 1162.3406948937966px',
							'595.9994373329582px 1162.3406948937966px',
							'595.5605570403714px 1162.3406948937966px',
							'593.8050358700239px 1162.4926149950766px',
							'592.3871149247433px 1162.7626951751301px',
							'590.6147137431425px 1162.7626951751301px',
							'589.0786327190884px 1162.7626951751301px',
							'588.2515121676747px 1162.7626951751301px',
							'587.3399915599944px 1162.7626951751301px',
							'586.377830918554px 1162.7795751863835px',
							'585.2975101983401px 1163.201575467717px',
							'583.7445491630327px 1163.3028555352369px',
							'581.3813475875651px 1163.8430158953438px',
							'578.6974257982838px 1164.1299760866507px',
							'577.1782247854832px 1164.1299760866507px',
							'575.9966239977493px 1164.1299760866507px',
							'574.0385426923617px 1164.5182163454774px',
							'572.7050218033478px 1164.6026164017442px',
							'571.6584611056408px 1164.6026164017442px',
							'569.6834997889998px 1164.6026164017442px',
							'567.1514981009987px 1164.6026164017442px',
							'565.6660571107047px 1164.6026164017442px',
							'564.3831762554508px 1164.6026164017442px',
							'562.9483752989169px 1164.8558165705442px',
							'561.9862146574765px 1165.0246166830777px',
							'561.0071740047827px 1165.0246166830777px',
							'560.1631734421156px 1165.0246166830777px',
							'559.7918131945421px 1165.0246166830777px',
							'558.0869320579546px 1165.0246166830777px',
							'557.2935715290477px 1165.0246166830777px',
							'556.6014910676607px 1165.0246166830777px',
							'556.4664509776339px 1165.0246166830777px',
							'556.1963707975805px 1165.0246166830777px',
							'555.2679701786468px 1165.0246166830777px',
							'553.7150091433394px 1165.429736953158px',
							'551.7062878041918px 1165.5141370094245px',
							'550.4740469826979px 1165.5141370094245px',
							'549.0561260374174px 1165.5141370094245px',
							'547.8070052046701px 1165.5141370094245px',
							'546.7604445069629px 1165.5141370094245px',
							'545.8320438880293px 1165.5141370094245px',
							'545.5619637079758px 1165.5141370094245px',
							'545.0386833591222px 1165.8517372344913px',
							'544.0765227176818px 1165.9698973132647px',
							'543.6376424250949px 1165.9698973132647px',
							'542.4898016598678px 1165.9698973132647px',
							'541.7133211422141px 1165.9698973132647px',
							'541.3926009284006px 1165.9698973132647px',
							'540.9030806020537px 1165.9698973132647px',
							'540.4304402869602px 1165.9698973132647px',
							'539.4851596567731px 1165.9698973132647px',
							'539.0293993529328px 1165.9698973132647px',
							'537.9828386552257px 1165.9698973132647px',
							'537.9153186102124px 1165.9698973132647px',
							'537.6452384301589px 1165.9698973132647px',
							'536.7843578562386px 1165.9698973132647px',
							'535.3326768884513px 1165.9698973132647px',
							'534.8431565621044px 1165.9698973132647px',
							'534.2017161344774px 1165.9698973132647px',
							'533.5433956955972px 1165.9698973132647px',
							'533.1551554367703px 1165.9698973132647px',
							'533.0369953579968px 1165.9698973132647px',
							'533.0369953579968px 1165.9698973132647px',
							'529.6947531298354px 1165.9698973132647px',
							'526.6732311154874px 1165.9698973132647px',
							'523.4491489660993px 1165.9698973132647px',
							'520.6639471092981px 1166.3412575608384px',
							'519.8874665916444px 1166.3581375720917px',
							'519.1447460964973px 1166.3581375720917px',
							'518.1994654663102px 1166.3581375720917px',
							'517.5073850049233px 1166.3581375720917px',
							'517.3723449148965px 1166.3581375720917px',
							'517.3723449148965px 1166.3581375720917px',
							'516.5789843859895px 1166.3581375720917px',
							'515.5830637220424px 1166.3581375720917px',
							'514.5871430580953px 1166.7801378534252px',
							'514.3845829230553px 1166.7970178646785px',
							'514.3845829230553px 1166.7970178646785px',
							'513.2873821915881px 1166.7970178646785px',
							'509.9282599521733px 1166.7970178646785px',
							'509.6750597833732px 1166.7970178646785px',
							'508.9829793219862px 1166.7970178646785px',
							'508.2908988605992px 1166.7970178646785px',
							'507.56505837670557px 1166.9995779997187px',
							'506.72105781403855px 1167.117738078492px',
							'506.4678576452384px 1167.117738078492px',
							'506.4678576452384px 1167.117738078492px',
							'506.80545787030525px 1168.164298776199px',
							'510.4346602897735px 1181.7527078351386px',
							'514.1651427767619px 1192.9441552961034px',
							'515.9206639471092px 1202.7176818117878px',
							'518.1150654100436px 1215.3439302292868px',
							'526.9433112955409px 1236.5958643972428px',
							'535.2482768321845px 1249.5934730623153px',
							'549.2418061612041px 1267.5369250246167px',
							'556.4495709663806px 1274.9641299760865px',
							'564.1806161204107px 1280.8383738922491px',
							'571.6753411168941px 1285.294696863131px',
							'587.5763117175411px 1290.6625404416936px',
							'603.9499226332817px 1293.700942467295px',
							'631.1942607961738px 1296.8912645941764px',
							'656.4973976649318px 1298.8493458995638px',
							'667.50316500211px 1300.1659867773244px',
							'684.9570966380644px 1301.229427486285px',
							'708.5722323814882px 1303.6263890842592px',
							'743.6488957659304px 1306.580391053594px',
							'798.0700520467013px 1309.3993529329018px',
							'843.4435222956815px 1311.7456744971162px',
							'864.9486566324377px 1312.67407511605px',
							'896.9362779575185px 1313.7375158250104px',
							'924.4506963004642px 1315.5267970178645px',
							'970.9888873259248px 1316.5733577155718px',
							'1038.9140526093684px 1316.5733577155718px',
							'1114.0469826979884px 1316.9447179631452px',
							'1165.581657054438px 1318.1431987621324px',
							'1244.7151498100998px 1319.7636798424533px',
							'1321.8568012378673px 1323.3422422281615px',
							'1451.7991278660852px 1329.6384864256574px',
							'1576.1035307356872px 1335.4620903080602px',
							'1694.4830496553664px 1340.8130538753692px',
							'1742.9624419749612px 1342.2478548319032px',
							'1807.7985651990434px 1344.6110564073708px',
							'1857.054438036292px 1345.7757771838515px',
							'1926.2287241524828px 1349.1855394570262px',
							'1999.5723730482487px 1352.9329019552679px',
							'2063.19313546209px 1354.6884231256154px',
							'2085.4747503165px 1355.2961035307355px',
							'2117.310451540301px 1357.304824869883px',
							'2142.225348150232px 1358.4695456463637px',
							'2183.9020959347304px 1362.2337881558587px',
							'2224.144042762695px 1365.7448304965535px',
							'2276.1175974117314px 1371.011394007596px',
							'2313.439302292868px 1375.1976367984244px',
							'2327.854831903221px 1376.412997608665px',
							'2338.3373188915457px 1377.510198340132px',
							'2350.929807286538px 1379.5357996905332px',
							'2366.2062174708117px 1381.2238008158672px',
							'2383.8458292305527px 1383.890842593895px',
							'2423.632015754677px 1389.039246026164px',
							'2478.2894921929947px 1396.3314108876073px',
							'2547.9195386130255px 1407.168378112252px',
							'2620.4698269798846px 1419.6089464059642px',
							'2682.503868335912px 1430.2771135180756px',
							'2739.642706428471px 1440.4726403150935px',
							'2794.7559431706286px 1449.8410465606976px',
							'2835.63933042622px 1456.491770994514px',
							'2883.038402025601px 1463.6826557884372px',
							'2895.5802503868335px 1465.0330566887044px',
							'2904.0540160360106px 1466.6197777465184px',
							'2905.8264172176114px 1466.754817836545px',
							'2905.8264172176114px 1466.754817836545px',
							'2906.4847376564917px 1467.396258264172px',
							'2909.6919397946263px 1470.0295400196933px',
							'2911.599381066254px 1471.9369812913208px',
							'2911.785061190041px 1472.5277816851876px',
							'2914.030102686735px 1476.3257842171895px',
							'2919.8030665353776px 1482.1831481220986px',
							'2924.343789562526px 1485.2046701364468px',
							'2925.238430158953px 1485.761710507807px',
							'2925.238430158953px 1485.761710507807px',
							'2925.4578703052466px 1486.065550710367px',
							'2927.196511464341px 1488.2768321845547px',
							'2928.6650724433816px 1489.3740329160219px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</>
	);
};

const PitchCorrectionContent = () => {
	const {fps} = useVideoConfig();
	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 1976,
				height: 1440,
				left: '50%',
				top: '50%',
				translate: '-1100px -860px',
				transformOrigin: '1100px 860px',
				rotate: '-0.747627 0.633442 -0.19951 27.805983deg',
				scale: 1.2,
			}}
			playbackRate={2.3}
			from={(-81 / 60) * fps}
		>
			<PitchCorr />
		</AbsoluteFill>
	);
};

const PitchCorrectionPreviewContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<CloseUpFrame>
			<div
				style={{
					position: 'absolute',
					width: 1920,
					height: (height * 1920) / width,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					scale: Math.min(width / 1920, height / 1080),
					overflow: 'visible',
				}}
			>
				<PitchCorrectionContent />
			</div>
		</CloseUpFrame>
	);
};

export const PitchCorrectionPreview = Interactive.create({
	Component: PitchCorrectionPreviewContent,
	layout: 'absolute-fill',
	schema: {},
});

export const PitchCorrection = () => {
	return (
		<Composition
			id={'PitchCorrection'}
			component={PitchCorrectionPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={337}
		/>
	);
};
